<div
  data-omni-qa="omni-icon-chat-collapsible-bubble"
  *cignaResponsive="let screen"
>
  <!-- For expanded chat icon with text -->
  <svg
    *ngIf="
      (isLiveChatAvailability && !shouldExpand) ||
      (!canShellOpenOrMinimized && hasShellMinimized)
    "
    width="186px"
    height="74px"
    viewBox="0 0 186 74"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <defs>
      <path
        d="M28,0 L140,0 C155.463973,-2.84068575e-15 168,12.536027 168,28 C168,43.463973 155.463973,56 140,56 L28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
        id="path-1"
      ></path>
      <filter
        x="-9.2%"
        y="-20.5%"
        width="118.5%"
        height="155.4%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feMorphology
          radius="0.5"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="4"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <linearGradient
        x1="50%"
        y1="-13.0092076%"
        x2="50%"
        y2="100%"
        id="linearGradient-3"
      >
        <stop stop-color="#0EC543" offset="0%"></stop>
        <stop stop-color="#008539" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="chatBubbleFull"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="DASH---CHAT-BUBBLE-FULL"
        transform="translate(-1391.000000, -3997.000000)"
      >
        <g
          id="Chat-Bubble-Expand"
          transform="translate(1400.000000, 4002.000000)"
        >
          <g id="Shadow" fill="black" fill-opacity="1">
            <use filter="url(#filter-2)" xlink:href="#path-1"></use>
          </g>
          <path
            d="M28,0 L140,0 C155.463973,-2.84068575e-15 168,12.536027 168,28 C168,43.463973 155.463973,56 140,56 L28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
            id="Button"
            [attr.fill]="backgroundColor"
          ></path>
          <path
            d="M37.7777778,20 C38.4527925,20 39,20.5522371 39,21.2334561 L39,33.5680173 C39,34.2492363 38.4527925,34.8014734 37.7777778,34.8014734 L26.2668889,34.8014734 L21.7282609,39.8000066 C21.5001988,40.0510884 21.1136299,40.0680502 20.8648349,39.837892 C20.7385617,39.7210775 20.6666667,39.5561411 20.6666667,39.3832683 L20.6666667,34.8014734 L18.2222222,34.8014734 C17.5472075,34.8014734 17,34.2492363 17,33.5680173 L17,21.2334561 C17,20.5522371 17.5472075,20 18.2222222,20 L37.7777778,20 Z"
            id="Path"
            fill="#FFFFFF"
          ></path>
          <path
            d="M57.18,33.18 C59.205,33.18 60.405,32.46 61.485,31.305 L60.015,29.82 C59.19,30.57 58.455,31.05 57.255,31.05 C55.455,31.05 54.21,29.55 54.21,27.75 L54.21,27.72 C54.21,25.92 55.485,24.45 57.255,24.45 C58.305,24.45 59.13,24.9 59.94,25.635 L61.41,23.94 C60.435,22.98 59.25,22.32 57.27,22.32 C54.045,22.32 51.795,24.765 51.795,27.75 L51.795,27.78 C51.795,30.795 54.09,33.18 57.18,33.18 Z M65.37,33 L65.37,28.515 C65.37,27.435 65.925,26.88 66.795,26.88 C67.665,26.88 68.175,27.435 68.175,28.515 L68.175,33 L70.455,33 L70.455,27.795 C70.455,25.95 69.45,24.81 67.725,24.81 C66.57,24.81 65.895,25.425 65.37,26.1 L65.37,22.05 L63.09,22.05 L63.09,33 L65.37,33 Z M74.715,33.15 C75.825,33.15 76.59,32.745 77.145,32.13 L77.145,33 L79.35,33 L79.35,28.335 C79.35,27.255 79.08,26.37 78.48,25.77 C77.91,25.2 77.01,24.87 75.765,24.87 C74.4,24.87 73.53,25.125 72.645,25.515 L73.215,27.255 C73.95,26.985 74.565,26.82 75.435,26.82 C76.575,26.82 77.16,27.345 77.16,28.29 L77.16,28.425 C76.59,28.23 76.005,28.095 75.195,28.095 C73.29,28.095 71.955,28.905 71.955,30.66 L71.955,30.69 C71.955,32.28 73.2,33.15 74.715,33.15 Z M75.405,31.575 C74.67,31.575 74.16,31.215 74.16,30.6 L74.16,30.57 C74.16,29.85 74.76,29.46 75.735,29.46 C76.29,29.46 76.8,29.58 77.19,29.76 L77.19,30.165 C77.19,30.99 76.47,31.575 75.405,31.575 Z M84.03,33.135 C84.795,33.135 85.35,32.955 85.83,32.67 L85.83,30.84 C85.5,31.02 85.125,31.125 84.705,31.125 C84.195,31.125 83.97,30.87 83.97,30.345 L83.97,26.91 L85.86,26.91 L85.86,24.96 L83.97,24.96 L83.97,22.905 L81.69,22.905 L81.69,24.96 L80.73,24.96 L80.73,26.91 L81.69,26.91 L81.69,30.72 C81.69,32.58 82.635,33.135 84.03,33.135 Z M97.065,33.075 L99.435,26.205 L101.805,33.075 L103.815,33.075 L107.4,22.5 L104.985,22.5 L102.81,29.61 L100.455,22.47 L98.475,22.47 L96.12,29.61 L93.945,22.5 L91.47,22.5 L95.055,33.075 L97.065,33.075 Z M110.481667,24.075 L110.481667,22.05 L108.081667,22.05 L108.081667,24.075 L110.481667,24.075 Z M110.421667,33 L110.421667,24.96 L108.141667,24.96 L108.141667,33 L110.421667,33 Z M115.281667,33.135 C116.046667,33.135 116.601667,32.955 117.081667,32.67 L117.081667,30.84 C116.751667,31.02 116.376667,31.125 115.956667,31.125 C115.446667,31.125 115.221667,30.87 115.221667,30.345 L115.221667,26.91 L117.111667,26.91 L117.111667,24.96 L115.221667,24.96 L115.221667,22.905 L112.941667,22.905 L112.941667,24.96 L111.981667,24.96 L111.981667,26.91 L112.941667,26.91 L112.941667,30.72 C112.941667,32.58 113.886667,33.135 115.281667,33.135 Z M121.071667,33 L121.071667,28.515 C121.071667,27.435 121.626667,26.88 122.496667,26.88 C123.366667,26.88 123.876667,27.435 123.876667,28.515 L123.876667,33 L126.156667,33 L126.156667,27.795 C126.156667,25.95 125.151667,24.81 123.426667,24.81 C122.271667,24.81 121.596667,25.425 121.071667,26.1 L121.071667,22.05 L118.791667,22.05 L118.791667,33 L121.071667,33 Z M137.256667,33.165 C140.076667,33.165 141.861667,31.605 141.861667,28.425 L141.861667,22.5 L139.551667,22.5 L139.551667,28.515 C139.551667,30.18 138.696667,31.035 137.286667,31.035 C135.876667,31.035 135.021667,30.15 135.021667,28.44 L135.021667,22.5 L132.711667,22.5 L132.711667,28.5 C132.711667,31.59 134.436667,33.165 137.256667,33.165 Z M146.796667,33.15 C148.536667,33.15 149.871667,32.34 149.871667,30.555 L149.871667,30.525 C149.871667,29.055 148.566667,28.515 147.441667,28.14 C146.571667,27.84 145.806667,27.63 145.806667,27.18 L145.806667,27.15 C145.806667,26.835 146.091667,26.595 146.646667,26.595 C147.231667,26.595 148.026667,26.88 148.821667,27.345 L149.691667,25.77 C148.821667,25.185 147.711667,24.84 146.691667,24.84 C145.071667,24.84 143.751667,25.755 143.751667,27.39 L143.751667,27.42 C143.751667,28.98 145.026667,29.505 146.151667,29.835 C147.036667,30.105 147.816667,30.27 147.816667,30.765 L147.816667,30.795 C147.816667,31.155 147.516667,31.395 146.856667,31.395 C146.106667,31.395 145.191667,31.065 144.321667,30.435 L143.346667,31.935 C144.411667,32.775 145.671667,33.15 146.796667,33.15 Z"
            id="ChatWithUs"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>

  <!-- Only Chat Icon Without Text -->
  <svg
    *ngIf="
      (isLiveChatAvailability &&
        !canShellOpenOrMinimized &&
        !hasShellMinimized &&
        shouldExpand) ||
      (canShellOpenOrMinimized && hasShellMinimized && shouldExpand)
    "
    width="74px"
    height="74px"
    viewBox="0 0 74 74"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <defs>
      <path
        d="M28,0 C43.463973,-2.84068575e-15 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
        id="path-1"
      ></path>
      <filter
        x="-27.7%"
        y="-20.5%"
        width="155.4%"
        height="155.4%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feMorphology
          radius="0.5"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="4"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <linearGradient
        x1="50%"
        y1="-13.0092076%"
        x2="50%"
        y2="100%"
        id="linearGradient-3"
      >
        <stop stop-color="#0EC543" offset="0%"></stop>
        <stop stop-color="#008539" offset="100%"></stop>
      </linearGradient>
      <circle id="path-4" cx="47" cy="9" r="8"></circle>
      <filter
        x="-21.9%"
        y="-15.6%"
        width="143.8%"
        height="143.8%"
        filterUnits="objectBoundingBox"
        id="filter-5"
      >
        <feMorphology
          radius="0.5"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="1"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="0.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      id="DEMO-MVP"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="DASH---CHAT-ALERT"
        transform="translate(-1503.000000, -3997.000000)"
      >
        <g
          id="Chat-Bubble---Alert"
          transform="translate(1512.000000, 4002.000000)"
        >
          <g id="Shadow" fill="black" fill-opacity="1">
            <use filter="url(#filter-2)" xlink:href="#path-1"></use>
          </g>
          <path
            d="M28,0 C43.463973,-2.84068575e-15 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
            id="Button"
            [attr.fill]="backgroundColor"
          ></path>
          <g id="Alert-Dot" *ngIf="data?.showNotificationBadge">
            <use
              fill="black"
              fill-opacity="1"
              filter="url(#filter-5)"
              xlink:href="#path-4"
            ></use>
            <use fill="#FF0000" fill-rule="evenodd" xlink:href="#path-4"></use>
          </g>
          <text
            id="4"
            font-family="GothamSSm-Black, Gotham SSm"
            font-size="9"
            text-align="center"
            font-weight="normal"
            line-spacing="9"
            fill="#FFFFFF"
            *ngIf="data?.showNotificationBadge"
          >
            <tspan x="63%" y="12.289" text-anchor="middle">
              {{ data?.badgeCount }}
            </tspan>
          </text>
          <path
            d="M37.7777778,20 C38.4527925,20 39,20.5522371 39,21.2334561 L39,33.5680173 C39,34.2492363 38.4527925,34.8014734 37.7777778,34.8014734 L26.2668889,34.8014734 L21.7282609,39.8000066 C21.5001988,40.0510884 21.1136299,40.0680502 20.8648349,39.837892 C20.7385617,39.7210775 20.6666667,39.5561411 20.6666667,39.3832683 L20.6666667,34.8014734 L18.2222222,34.8014734 C17.5472075,34.8014734 17,34.2492363 17,33.5680173 L17,21.2334561 C17,20.5522371 17.5472075,20 18.2222222,20 L37.7777778,20 Z"
            id="Chat-Icon"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </g>
  </svg>

  <!-- Minimized chevron Icon -->
  <svg
    *ngIf="canShellOpenOrMinimized && !hasShellMinimized"
    width="74px"
    height="74px"
    viewBox="0 0 74 74"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
  >
    <defs>
      <path
        d="M28,0 C43.463973,-2.84068575e-15 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
        id="path-1"
      ></path>
      <filter
        x="-27.7%"
        y="-20.5%"
        width="155.4%"
        height="155.4%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feMorphology
          radius="0.5"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="4"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <linearGradient
        x1="-1.35308431e-13%"
        y1="-3.45556916e-13%"
        x2="100%"
        y2="100%"
        id="linearGradient-3"
      >
        <stop stop-color="#0EC543" offset="0%"></stop>
        <stop stop-color="#008539" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="chatOpen"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="DASH---CHAT-OPEN"
        transform="translate(-1503.000000, -3997.000000)"
      >
        <g
          id="Chat-Bubble---Min"
          transform="translate(1512.000000, 4002.000000)"
        >
          <g id="Shadow" fill="black" fill-opacity="1">
            <use filter="url(#filter-2)" xlink:href="#path-1"></use>
          </g>
          <path
            d="M28,0 C43.463973,-2.84068575e-15 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
            id="Button"
            [attr.fill]="backgroundColor"
          ></path>
          <path
            d="M31.9409102,19.3352608 C32.6121238,18.7215797 33.7003762,18.7215797 34.3715898,19.3352608 C34.9911716,19.9017356 35.0388317,20.7930987 34.5145702,21.4095563 L34.3715898,21.5575964 L25.2757812,29.875 L34.3715898,38.1924036 C34.9911716,38.7588784 35.0388317,39.6502415 34.5145702,40.2666991 L34.3715898,40.4147392 C33.752008,40.981214 32.7770796,41.024789 32.1028291,40.5454642 L31.9409102,40.4147392 L21.6284102,30.9861678 C21.0088284,30.419693 20.9611683,29.5283299 21.4854298,28.9118723 L21.6284102,28.7638322 L31.9409102,19.3352608 Z"
            id="Icon-/-Nav-/-Arrow-/-Down"
            fill="#FFFFFF"
            transform="translate(28.000000, 29.875000) rotate(-90.000000) translate(-28.000000, -29.875000) "
          ></path>
        </g>
      </g>
    </g>
  </svg>

  <!-- Live Chat is not available or in holiday hours -->
  <svg
    width="74px"
    height="74px"
    viewBox="0 0 74 74"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    *ngIf="!isLiveChatAvailability && !canShellOpenOrMinimized"
    aria-hidden="true"
  >
    <defs>
      <path
        d="M28,0 C43.463973,-2.84068575e-15 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
        id="path-1"
      ></path>
      <filter
        x="-27.7%"
        y="-20.5%"
        width="155.4%"
        height="155.4%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feMorphology
          radius="0.5"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="4"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <linearGradient
        x1="49.2928677%"
        y1="-4.08818595%"
        x2="17.807922%"
        y2="92.3111608%"
        id="linearGradient-3"
      >
        <stop stop-color="#E7E7E7" offset="0%"></stop>
        <stop stop-color="#B7B7B7" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g
      id="DEMO-MVP"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="DASH---CHAT---OFF-HOURS"
        transform="translate(-1503.000000, -3997.000000)"
      >
        <g id="Chat-Closed" transform="translate(1512.000000, 4002.000000)">
          <g id="Shadow" fill="black" fill-opacity="1">
            <use filter="url(#filter-2)" xlink:href="#path-1"></use>
          </g>
          <path
            d="M28,0 C43.463973,-2.84068575e-15 56,12.536027 56,28 C56,43.463973 43.463973,56 28,56 C12.536027,56 1.8937905e-15,43.463973 0,28 C-1.8937905e-15,12.536027 12.536027,2.84068575e-15 28,0 Z"
            id="Button"
            fill="url(#linearGradient-3)"
          ></path>
          <path
            d="M24.5633936,20.0005007 C24.6094482,20.1278156 24.6655476,20.2503223 24.7307348,20.3670635 L24.7307348,20.3670635 L24.752,20.403 L24.6662796,20.5390645 L24.5775328,20.7050564 C24.4127711,21.0432616 24.325,21.4172887 24.325,21.8 L24.325,21.8 L24.325,23.05 L24.3303177,23.2143757 C24.4149613,24.5184641 25.4995166,25.55 26.825,25.55 L26.825,25.55 L31.845,25.55 L32.0403593,25.5424745 C32.2337525,25.5275112 32.420965,25.4904977 32.5994585,25.4338018 C32.8378278,25.5092833 33.0916589,25.55 33.355,25.55 L33.355,25.55 L38.375,25.55 L38.5706283,25.5424635 C38.7642847,25.5274885 38.9517421,25.4904915 39.1304518,25.4341161 L39,25.469 L39,33.5680173 C39,34.2492363 38.4527925,34.8014734 37.7777778,34.8014734 L26.2668889,34.8014734 L21.7282609,39.8000066 C21.5001988,40.0510884 21.1136299,40.0680502 20.8648349,39.837892 C20.7385617,39.7210775 20.6666667,39.5561411 20.6666667,39.3832683 L20.6666667,34.8014734 L18.2222222,34.8014734 C17.5472075,34.8014734 17,34.2492363 17,33.5680173 L17,21.2334561 C17,20.5522371 17.5472075,20 18.2222222,20 Z"
            id="Combined-Shape"
            fill="#FFFFFF"
          ></path>
          <path
            d="M31.845,21.54 L29.335,21.54 L31.845,18.89 L31.845,17.64 L26.915,17.64 L26.915,19.15 L29.325,19.15 L26.825,21.8 L26.825,23.05 L31.845,23.05 L31.845,21.54 Z M38.375,23.05 L38.375,21.54 L35.865,21.54 L38.375,18.89 L38.375,17.64 L33.445,17.64 L33.445,19.15 L35.855,19.15 L33.355,21.8 L33.355,23.05 L38.375,23.05 Z M44.905,23.05 L44.905,21.54 L42.395,21.54 L44.905,18.89 L44.905,17.64 L39.975,17.64 L39.975,19.15 L42.385,19.15 L39.885,21.8 L39.885,23.05 L44.905,23.05 Z"
            id="zzz"
            fill="#585858"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</div>
